// extracted by mini-css-extract-plugin
export default {"overlay":"Popup_overlay__nJfrX","popup":"Popup_popup__vqsOE"};